function getDiscountedRequiredPension(amountOnFirstYear, term, retirementAge, i, isMale, g, inflation, isFuture){
  let ExpectedAge

  if(isMale) {
    ExpectedAge = 90;
  } else {
    ExpectedAge = 93;
  }

  let v1 = 1 / (1.03);
  let r = (1 + g) * v1;
  let m = (1 / r) - 1;
  let v2 = 1 / (1 + m);
  let Term2 = ExpectedAge - retirementAge;
  let AN = (1 - Math.pow(v2, Term2)) / (1 - v2);

  let RequiredPension = amountOnFirstYear * AN;
  RequiredPension = RequiredPension.toFixed(0);


  if(isFuture) {
    return RequiredPension
  }

  let Discounted_RequiredPension = RequiredPension * Math.pow((1 / (1 + inflation)), term);
  return Discounted_RequiredPension.toFixed(0);
}

export function calculateRetirement(
  isMale,
  currentAge,
  retirementAge,
  amountOnFirstYear,
  savingsToDate,
  amountOfSavingsToSaveForCurrentYear,
  currentPensionPotSize,
  amountToAddToPensionPotThisYear,
  pensionPotGrowthRate,
  isFuture
){
  const term = retirementAge - currentAge;
  const Term_months = term * 12;
  const i = pensionPotGrowthRate / 100;
  const j = Math.pow((1.0 + i), (1.0 / 12)) - 1;

  let Savings = parseInt(savingsToDate) + parseInt(currentPensionPotSize);
  Savings = Savings * Math.pow((1 + j), Term_months);
  Savings = Savings.toFixed(0);

  let g, inflation

  if(i === 0.03) {
    g = 0.01;
    inflation = 0.015;
  } else if(i === 0.06) {
    g = 0.015;
    inflation = 0.03;
  } else {
    g = 0.02;
    inflation = 0.045;
  }

  let Sum = ((Math.pow((1 + j), Term_months) - 1) / j) * (1 + j);
  let Monthly_Savings = amountOfSavingsToSaveForCurrentYear / 12;
  let Monthly_Pension = amountToAddToPensionPotThisYear / 12;
  let MonthlyPayment = Monthly_Savings + Monthly_Pension;
  let Answer = Sum * MonthlyPayment;
  let Total = Answer + Number(Savings);
  Total = Total.toFixed(0);
  let Discounted_ActualPension = Total * Math.pow((1 / (1 + inflation)), term);
  Discounted_ActualPension = Discounted_ActualPension.toFixed(0);

  console.log(Total)

  const data = {
    "Current age": currentAge,
    "Retirement age": retirementAge,
    "Money already saved": savingsToDate,
    "Current pension pot": currentPensionPotSize,
    "Savings + Pension + Growth": Savings,
    "Expected savings per year": amountOfSavingsToSaveForCurrentYear,
    "Expected pension savings per year": amountToAddToPensionPotThisYear,
    "Assumed growth rate": pensionPotGrowthRate,
    "At retirement you will need": getDiscountedRequiredPension(amountOnFirstYear, term, retirementAge, i, isMale, g, inflation, isFuture),
    "At retirement you will have saved": isFuture ? Total : Discounted_ActualPension,
  }

  return data;
}
